import { Injectable } from '@angular/core';
import { AsyncExporter, ExporterDescriptor } from '../models/exporter';
import { JiraOptionsComponent } from '../components/jira-options/jira-options.component';

/**
 * Jira Exporter (descriptor solo).
 *
 * Toda la lógica del push vive en el backend (workers/handlers/jira.handler.js).
 * El frontend solo declara:
 *   - mode: 'async'                            → encolado a `/api/exports/jobs`
 *   - requiredPermission: integration:jira:push → RBAC frontend
 *   - requiresIntegration: 'jira'              → panel renderiza chip OAuth
 *   - optionsComponent: JiraOptionsComponent   → sub-formulario montado dinámicamente
 *   - supportsExtras: true                      → toggle "Incluir campos completos"
 *
 * Icono: "open in new" (path estándar Material) — sin usar el logo Jira
 * (trademark). Generico y semánticamente correcto para "push a sistema externo".
 *
 * @author Marcos Cordo
 * @version 07/06/2026_1
 */
@Injectable({ providedIn: 'root' })
export class JiraExporter implements AsyncExporter {
  readonly descriptor: ExporterDescriptor & { mode: 'async' } = {
    id: 'jira',
    label: 'Jira',
    shortHint: 'Crear issues',
    iconSvgPath:
      'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
    mode: 'async',
    requiredPermission: 'integration:jira:push',
    requiresIntegration: 'jira',
    supportsExtras: true,
    optionsComponent: JiraOptionsComponent,
    order: 40
  };
}
